import { bigIntParser } from "../utils/functions/bigIntParser";
import { endpointGenerator } from "../utils/functions/endpointGenerator";
import { type Execution } from "../utils/functions/execution";
import {
    type Chain,
    type GoldRushResponse,
} from "../utils/types/Generic.types";
import { type ApprovalsResponse } from "../utils/types/SecurityService.types";

/**
 * Approvals API
 *
 */
export class SecurityService {
    constructor(private execution: Execution) {}

    /**
     *
     * Commonly used to get a list of approvals across all token contracts categorized by spenders for a wallet’s assets.
     *
     * **Credit Cost**: 2 per call
     *
     * @param {Chain} chainName - The chain name eg: `eth-mainnet` or 1.
     * @param {string} walletAddress - The requested address. Passing in an `ENS`, `RNS`, `Lens Handle`, or an `Unstoppable Domain` resolves automatically.
     *
     */
    public async getApprovals(
        chainName: Chain,
        walletAddress: string
    ): Promise<GoldRushResponse<ApprovalsResponse>> {
        const endpoint = endpointGenerator(
            `${chainName}/approvals/${walletAddress}`,
            []
        );

        const parseData = (data: GoldRushResponse<ApprovalsResponse>) => {
            if (data.data) {
                data.data.updated_at = data.data.updated_at
                    ? new Date(data.data.updated_at)
                    : null;
                data.data.items = data.data.items
                    ? data.data.items.map((approvalItem) => ({
                          ...approvalItem,
                          balance: bigIntParser(approvalItem.balance),
                          spenders: approvalItem.spenders
                              ? approvalItem.spenders.map((spenderItem) => ({
                                    ...spenderItem,
                                    block_signed_at: spenderItem.block_signed_at
                                        ? new Date(spenderItem.block_signed_at)
                                        : null,
                                }))
                              : null,
                      }))
                    : null;
            }

            return data;
        };

        return await this.execution.execute<ApprovalsResponse>(
            endpoint,
            parseData
        );
    }
}
